import { MapMarker } from "@/types/map-marker"
import { Place } from "@/types/place"

import { selectSpacedMarkers } from "@/lib/map-marker-spacing"
import {
  isPlaceBasedMarker,
  mapMarkerId,
  mapMarkerPlace,
} from "@/lib/map-marker-utils"
import { useMapState } from "./map-state-context"
import { PlaceMarker } from "./place-marker"

export interface NearbyMarkerLayerProps {
  markers: MapMarker[]
  /** Higher-priority markers that block nearby markers at the same screen position. */
  avoidMarkers?: MapMarker[]
  /** Hidden until current zoom > minZoom. Default 0 (always visible). */
  minZoom?: number
  showCard?: boolean
  onUserInteraction?: () => void
  onMarkerClick?: (place: Place) => void
}

/** Slim "nearby" markers gated on zoom (used by chat / explore). */
export function NearbyMarkerLayer({
  markers,
  avoidMarkers = [],
  minZoom = 0,
  showCard,
  onUserInteraction,
  onMarkerClick,
}: NearbyMarkerLayerProps) {
  const { mapZoom } = useMapState()
  if (!mapZoom || mapZoom <= minZoom) return null

  const visibleMarkers = selectSpacedMarkers(markers, {
    zoom: mapZoom,
    avoid: avoidMarkers,
  })

  return (
    <>
      {visibleMarkers.filter(isPlaceBasedMarker).map((marker) => (
        <PlaceMarker
          key={`nearby_${mapMarkerId(marker)}`}
          place={mapMarkerPlace(marker)}
          isMinimal
          onUserInteraction={onUserInteraction}
          onMarkerClick={onMarkerClick}
          showCard={showCard}
          entitySheetTrackingContext="Map"
        />
      ))}
    </>
  )
}
